<template>
  <div class="reefer-list">
    <template>
      <span class="divider"></span>
      <div class="reefer-list__content">
        <div class="reefer-list__title">
          <p class="trucs-list__type">Your reefer options</p>
        </div>
        <div class="reefer-container" id="reefer-container" v-if="screenWidth > 800">
          <template v-if="carriersImages">
            <OptionsComponent
              v-for="(reefer, index) in filteredCarriers"
              :key="index"
              :carrier="reefer"
              :carrierImage="findCarrierImage(reefer)"
              :aditionalInsurance="aditionalInsurance"
              :loadingInsurance="loadingInsurance"
               :originalCarrierArray="originalCarrierArray"
              :isPartial="true"
              @optionSelected="optionSelected"
              class="mb-3"
            ></OptionsComponent>
          </template>
          <template v-if="reefer.length === 0 && !allNotificationsObtained">
            <p>We are working to obtain reefer carriers. This may take some time.</p>
            <b-spinner small label="Spinning"></b-spinner>
          </template>
          <div class="not-carriers">
            <p v-if="reefer.length === 0 && allNotificationsObtained && !isBranded">
              {{ $t("carriers.noCarriersFoundReefer") }}
            </p>
            <p v-if="reefer.length === 0 && allNotificationsObtained && isBranded">
              {{ $t("carriers.noCarriersFoundBranding") }}
            </p>
          </div>
        </div>
        <div class="reefer-container" id="reefer-container" v-if="screenWidth <= 800">
          <template v-if="carriersImages">
            <OptionsComponentResponsive
              v-for="(reefer, index) in filteredCarriers"
              :key="index"
              :carrier="reefer"
              :carrierImage="findCarrierImage(reefer)"
              :aditionalInsurance="aditionalInsurance"
              :loadingInsurance="loadingInsurance"
               :originalCarrierArray="originalCarrierArray"
              :isPartial="true"
              @optionSelected="optionSelected"
              class="mb-3"
            >
            </OptionsComponentResponsive>
          </template>
          <template v-if="reefer.length === 0 && !allNotificationsObtained">
            <p>We are working to obtain reefer carriers. This may take some time.</p>
            <b-spinner small label="Spinning"></b-spinner>
          </template>
          <div class="not-carriers">
            <p v-if="reefer.length === 0 && allNotificationsObtained && !isBranded">
              {{ $t("carriers.noCarriersFoundReefer") }}
            </p>
            <p v-if="reefer.length === 0 && allNotificationsObtained && isBranded">
              {{ $t("carriers.noCarriersFoundBranding") }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import onReSize from "@/Extend/onResize";
import OptionsComponent from "../CarriersOptions/OptionsComponent.vue";
import OptionsComponentResponsive from "../CarriersOptions/OptionsComponentResponsive.vue";
import UpdateAditionalInsurance from "../../../../../../../utils/updateAditionalInsurance";

export default {
  name: "Reefer",
  mixins: [onReSize],
  props: {
    reefer: Array,
    allNotificationsObtained: Boolean,
    filterByGuaranteed: Boolean,
    originalCarrierArray: Array
  },
  components: {
    OptionsComponent,
    OptionsComponentResponsive,
  },
  data() {
    return {
      filteredCarriers: [],
      aditionalInsurance: 35,
      loadingInsurance: false,
      carrierSelected: null,
      chosenLoad: null,
      isBranded: false,
    };
  },
  created() {
    this.chosenLoad = this.$store.getters["load/getChosenLoad"];
    const cargoValue = this.$store.getters["carriers/getChosenLoadCargoValue"];
    this.isBranded = this.$store.getters["login/getTokenInfo"].is_branded;
    this.aditionalInsurance = UpdateAditionalInsurance(
      cargoValue,
      this.$store.getters["carriers/getInsuranceCoveragePlan"]
    );
    if (this.filterByGuaranteed) {
      this.filteredCarriers = this.filterCarriersByGuaranteed(this.reefer);
    }
  },
  watch: {
    reefer: {
      immediate: true,
      handler() {
        this.filteredCarriers = [...this.reefer];
      },
    },
    chosenLoadCargoValue() {
      this.aditionalInsurance = UpdateAditionalInsurance(
        this.chosenLoadCargoValue,
        this.insuranceCoveragePlan
      );
    },
    insuranceCoveragePlan() {
      this.aditionalInsurance = UpdateAditionalInsurance(
        this.chosenLoadCargoValue,
        this.insuranceCoveragePlan
      );
    },
  },
  computed: {
    ...mapGetters({
      chosenLoadCargoValue: "carriers/getChosenLoadCargoValue",
      insuranceCoveragePlan: "carriers/getInsuranceCoveragePlan",
      carriersImages: "carriers/getCarriersImages",
    }),
  },
  methods: {
    findCarrierImage(reefer) {
      if (reefer.logo) {
        return { url: reefer.logo, carrier: reefer.carrier };
      }
      const newImage = this.carriersImages.find(
        (image) => image && image.name && reefer.carrier && image.name.includes(reefer.carrier)
      );
      if (newImage) {
        return newImage;
      }
      return { url: "" };
    },
    async optionSelected(params) {
      this.carrierSelected = params.carrierId;
      this.chosenLoad.insurance_required = params.isInsurance;
      this.chosenLoad.carrierName = params.carrierName;
      this.$store.commit("load/setChosenLoad", this.chosenLoad);
      if (params.changeView) {
        this.changeView("StopsInfo", params.loyaltyInsurance, params.pickup, params.isInsurance);
      }
      this.loadingInsurance = false;
    },
    filterCarriersByGuaranteed(carriers) {
      return carriers.filter((carrier) => {
        const serviceClass = carrier.serviceClass.toLowerCase();
        const serviceClassList = ["guaranteed", "expedited", "time critical", "accelerated"];
        return serviceClassList.some((item) => serviceClass.includes(item));
      });
    },
    changeView(routeName, loyaltyInsurance, pickup, insurance) {
      const id = this.carrierSelected;
      this.$router.push({
        name: routeName,
        params: {
          loadId: this.$route.params.loadId,
          carrierId: id,
          insurance
        },
        query: {
          pickup,
          insurance,
          ...(loyaltyInsurance === true && { loyaltyInsurance: true })
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
.reefer-list {
  &__content {
    width: 98%;
    margin: 20px auto;
  }
  &__type {
    margin: 0px;
  }
  &__title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 1rem;
    p {
      color: $color-primary-company;
      @include font-standart-text;
      font-weight: bold;
    }
    @media (max-width: 800px) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 5%;
      p {
        color: $color-primary-company;
        font-weight: bold;
        margin: 0;
        margin-bottom: 3%;
      }
    }
  }
}

.divider {
  display: inline-block;
  width: 100%;
  height: 0;
  border-bottom: 1px solid $color-border-container;
  margin-top: 25px;
  @media (max-width: 800px) {
    margin: 3% 0 4% 0;
  }
}
</style>
